import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!data) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export function useSeo({ title, description, path = "/", noindex = false, jsonLd = null }) {
  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${path}`;
    if (title) document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (title) {
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${origin}/og-image.jpg`);
    setMeta("name", "twitter:image", `${origin}/og-image.jpg`);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setLink("canonical", url);
    setJsonLd("ym-jsonld", jsonLd);
  }, [title, description, path, noindex, jsonLd]);
}

export function restaurantSchema(s, faqs) {
  const origin = window.location.origin;
  const graph = [
    {
      "@type": "Restaurant",
      "@id": `${origin}/#restaurant`,
      name: s.name || "Yeni Mercan Restoran",
      alternateName: "Yeni Mercan Restoran Buca",
      url: `${origin}/`,
      logo: `${origin}/brand/logo.png`,
      image: [`${origin}/og-image.jpg`, `${origin}/images/hero.jpg`, `${origin}/images/karisik.jpg`],
      telephone: s.phone,
      ...(s.email ? { email: s.email } : {}),
      priceRange: "₺₺",
      servesCuisine: ["Türk Mutfağı", "Ev Yemekleri", "Kahvaltı", "Izgara", "Kokoreç", "Çorba"],
      address: {
        "@type": "PostalAddress",
        streetAddress: s.address,
        addressLocality: "Buca",
        addressRegion: "İzmir",
        addressCountry: "TR",
      },
      areaServed: ["Buca", "İzmir"],
      hasMap: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s.map_query || "Yeni Mercan Restoran Buca İzmir")}`,
      openingHoursSpecification: [{
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        opens: "00:00",
        closes: "23:59",
      }],
      hasMenu: `${origin}/menu`,
      acceptsReservations: true,
      sameAs: [`https://www.instagram.com/${s.instagram || "yenimercanrestoranbuca"}/`],
    },
    {
      "@type": "WebSite",
      "@id": `${origin}/#website`,
      url: `${origin}/`,
      name: "Yeni Mercan Restoran",
      inLanguage: "tr-TR",
      publisher: { "@id": `${origin}/#restaurant` },
    },
  ];
  if (faqs?.length) {
    graph.push({
      "@type": "FAQPage",
      mainEntity: faqs.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
    });
  }
  return { "@context": "https://schema.org", "@graph": graph };
}
